// extracted by mini-css-extract-plugin
export var contactCard = "ContactCard-module--contactCard--3NTk_";
export var contactWraper = "ContactCard-module--contactWraper--Ia4S3";
export var contactContent = "ContactCard-module--contactContent--2xVzU";
export var contactInfo = "ContactCard-module--contactInfo--2xp8R";